<div class="ws-step">
  <div class="ws-step-header">
    <h3>Deal Stages</h3>
    <p class="text-muted">When a lead is interested, a deal gets created. It then moves through these stages until it closes as a Win or a Loss. You can reorder, rename, or add stages.</p>
  </div>

  <div class="ws-step-body">
    <div cdkDropList (cdkDropListDropped)="reorderStages($event)">
      @for (stage of stages; track stage.value; let i = $index) {
        <div class="ws-item-card" [ngClass]="[getCardClass(stage), stage.selected ? 'selected' : '']" cdkDrag>
          <i class="bi bi-grip-vertical ws-drag-handle" cdkDragHandle></i>
          <input type="checkbox" class="form-check-input ws-item-toggle"
            [ngClass]="{'ws-toggle-positive': stage.isTerminalSuccess, 'ws-toggle-negative': stage.isTerminalFailure}"
            [checked]="stage.selected" (change)="toggleStage(stage)" />
          <div class="ws-item-content">
            <div class="d-flex align-items-center gap-2">
              <span class="badge bg-secondary-subtle text-secondary">{{ i + 1 }}</span>
              <input class="form-control form-control-sm border-0 p-0 ws-item-name" [(ngModel)]="stage.name" />
            </div>
            <input class="form-control form-control-sm border-0 p-0 ws-item-meta mt-1" [(ngModel)]="stage.description" placeholder="Description (optional)" />
            <div class="ws-terminal-controls mt-1">
              @if (stage.isTerminalSuccess) {
                <span class="badge bg-success-subtle text-success">Won Stage</span>
              } @else if (stage.isTerminalFailure) {
                <span class="badge bg-danger-subtle text-danger">Lost Stage</span>
              } @else {
                <div class="ws-terminal-actions">
                  <button class="btn btn-sm btn-link p-0 text-success" (click)="setTerminalWin(stage)">
                    <i class="bi bi-trophy me-1"></i>Mark as Won
                  </button>
                  <span class="text-muted mx-1">|</span>
                  <button class="btn btn-sm btn-link p-0 text-danger" (click)="setTerminalLoss(stage)">
                    <i class="bi bi-x-circle me-1"></i>Mark as Lost
                  </button>
                </div>
              }
            </div>
          </div>
          <button class="btn btn-sm btn-link text-danger" (click)="removeStage(stage)"><i class="bi bi-x-lg"></i></button>
        </div>
      }
    </div>

    @if (!stages.length) {
      <div class="ws-empty-state">
        <i class="bi bi-funnel"></i>
        <p>No deal stages suggested. Add your own or provide feedback.</p>
      </div>
    }

    <!-- Add new stage -->
    <div class="d-flex align-items-center gap-2 mt-3">
      <input class="form-control form-control-sm" [(ngModel)]="newStageName" placeholder="Add new stage..." (keyup.enter)="addStage()" />
      <button class="btn btn-sm btn-outline-primary" (click)="addStage()" [disabled]="!newStageName.trim()">Add</button>
    </div>

    <!-- Feedback section -->
    <div class="ws-feedback-section">
      <div class="ws-feedback-label">Want different stages? Tell AI what to change:</div>
      <textarea [(ngModel)]="feedback" placeholder="e.g. We need stages for subscription sales — Trial, Demo Scheduled, Proposal Sent, Negotiation, Closed Won, Closed Lost"></textarea>
      <div class="ws-feedback-actions">
        <button class="btn btn-sm btn-outline-primary" (click)="submitFeedback()" [disabled]="!feedback.trim()">
          <i class="bi bi-stars me-1"></i> Regenerate with AI
        </button>
      </div>
    </div>

    <div class="ws-save-row">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving">
        @if (isSaving) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Save & Continue
      </button>
    </div>
  </div>
</div>
